import { Link } from "react-router-dom";
import { NOT_FOUND } from "@/data/pageCopy";

// The page behind any address that has no page behind it.
//
// Before this existed, the catch-all rewrite in netlify.toml answered every
// unknown URL with the homepage's HTML and a 200 status. Two things went wrong
// with that: a crawler was told a typo'd address was a real page and indexed it
// as a duplicate of the homepage, and a visitor got the header and the footer
// with nothing in between, because no React route matched and nothing rendered.
//
// The copy lives in src/data/pageCopy.js because the prerenderer writes the
// same words into build/404.html.

export default function NotFoundPage() {
  return (
    <div data-testid="not-found">
      <section className="relative pt-32 md:pt-36 pb-24 min-h-[70vh] overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-4">
            {NOT_FOUND.kicker}
          </p>
          <h1 className="font-heading font-medium tracking-tight leading-[1.02] text-4xl md:text-5xl text-white max-w-3xl">
            {NOT_FOUND.h1}
          </h1>
          <p className="mt-5 text-lg text-neutral-400 max-w-2xl leading-relaxed">
            {NOT_FOUND.lead}
          </p>

          <ul className="mt-12 grid gap-x-12 gap-y-5 sm:grid-cols-2 max-w-3xl">
            {NOT_FOUND.links.map((l) => (
              <li key={l.href}>
                <Link to={l.href} className="group block">
                  <span className="text-white font-medium group-hover:text-[#5B8CFF] transition-colors">
                    {l.t}
                  </span>
                  <span className="block text-sm text-neutral-500 mt-1 leading-relaxed">
                    {l.d}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
